import { createAdminUser, type UserAdminForm } from '@gozoki/api'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { CreateOrUpdateAdminForm } from '~/components/routes/admins/CreateOrUpdateAdminForm'
import { withRoutePermissions } from '~/utils/rbac'
import { getErrorMessageWithSentry } from '~/utils/sentry'

export const Route = createFileRoute('/_authenticated/users/admins/new')({
  staticData: {
    permission: ['edit', 'users'],
  },
  component: AddAdminPage,
})
withRoutePermissions(Route)

const EMPTY_ADMIN: UserAdminForm = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  adminRights: 0,
  storeId: null,
}

function AddAdminPage() {
  const navigate = useNavigate()

  return (
    <CreateOrUpdateAdminForm
      title="Ajouter un administrateur"
      submitLabel="Ajouter"
      defaultValues={EMPTY_ADMIN}
      onCancel={() => navigate({ to: '/users/bo' })}
      onSubmit={async (values) => {
        try {
          await createAdminUser({ ...values, storeId: values.storeId ?? undefined })
          navigate({ to: '/users/bo' })
        } catch (error) {
          toast.error(getErrorMessageWithSentry(error))
        }
      }}
    />
  )
}
